import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  DestroyRef,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges
} from '@angular/core';
import { findIndex, take } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatRadioModule } from '@angular/material/radio';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { PairsPipe } from '@app/shared/shared.imports';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-permissions',
  templateUrl: './permissions.component.html',
  styleUrls: ['./permissions.component.scss'],
  standalone: true,
  imports: [CommonModule, FormsModule, TranslateModule, MatGridListModule, MatRadioModule, MatCheckboxModule, PairsPipe]
})
export class PermissionsComponent implements OnChanges, OnInit, AfterViewInit {
  @Input() item: any;
  @Input() service: any;
  @Input() form: any;
  @Input() isEdit: any;
  @Input() isClone: any;

  @Output() UpdateFormFieldValue: EventEmitter<any> = new EventEmitter();

  formValue: any = {};

  selectedAllArray: {} = {};
  permissions: {
    val?: string;
    custom?: any;
  } = {};

  templateLoaded = false;
  requestCount = 0;

  private templateLoaded$: Subject<any> = new Subject<any>();
  private dataLoaded$: Subject<any> = new Subject<any>();

  constructor(private destroyRef: DestroyRef) {}

  handleAll(module: string, emit: boolean = true, updateForm: boolean = true): void {
    this.selectedAllArray[module] = { all: true, custom: [] };

    this.permissions[module].custom = {};
    this.formValue[module] = this.selectedAllArray[module];
    this.emitValues(emit, updateForm);
  }

  handleCustom(module: string, emit: boolean = true, updateForm: boolean = true): void {
    this.selectedAllArray[module] = { all: false, custom: [] };

    this.formValue[module] = this.selectedAllArray[module];
    this.emitValues(emit, updateForm);
  }

  clearAll(module: string, emit: boolean = true, updateForm: boolean = true): void {
    this.selectedAllArray[module] = { all: false, custom: [] };

    this.permissions[module].custom = {};
    this.formValue[module] = this.selectedAllArray[module];
    this.emitValues(emit, updateForm);
  }

  togglePermission(moduleName: string, permissionId: string, emit: boolean = true, updateForm: boolean = true): void {
    if (!this.selectedAllArray[moduleName]) {
      this.selectedAllArray[moduleName] = {};
    }
    const customArray = this.selectedAllArray[moduleName].custom;
    if (!customArray) {
      this.selectedAllArray[moduleName].custom = [];
    }
    if (customArray && customArray.length) {
      const item = customArray.find((x: string) => x === permissionId);
      if (item) {
        const itemIndex = customArray.indexOf(item);
        customArray.splice(itemIndex, 1);
      } else {
        this.selectedAllArray[moduleName].custom.push(permissionId);
      }
    } else {
      this.selectedAllArray[moduleName].custom.push(permissionId);
    }
    this.formValue[moduleName] = this.selectedAllArray[moduleName];
    this.emitValues(emit, updateForm);
  }

  emitValues(emit: boolean = true, updateForm: boolean = true) {
    if (emit) {
      this.UpdateFormFieldValue.emit({ fieldValue: this.formValue, updateForm });
    }
  }

  ngOnInit(): void {
    this.createTemplate();

    this.templateLoaded$.pipe(takeUntilDestroyed(this.destroyRef), take(1)).subscribe(() => {
      // console.log('templateLoaded$');

      this.dataLoaded$.pipe(takeUntilDestroyed(this.destroyRef), take(1)).subscribe(() => {
        // console.log('dataLoaded$');
        this.loadData();
      });
    });
  }

  ngAfterViewInit(): void {}

  ngOnChanges(changes: SimpleChanges): void {
    // console.log('changes');
    // console.log(changes);
    if (this.item) {
      this.requestCount++;
      this.dataLoaded$.next(null);
      // console.log(this.requestCount);
    }
  }

  createTemplate() {
    this.service.lists$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((listPrefix: any) => {
      if (listPrefix === 'roles-create') {
        const permissionsTemplate = this.service.lists['roles-create'].permissions;
        if (permissionsTemplate) {
          for (const permissionsKey of Object.keys(permissionsTemplate)) {
            this.permissions[permissionsKey] = {};
            this.permissions[permissionsKey].custom = {};
            this.selectedAllArray[permissionsKey] = {};
            this.selectedAllArray[permissionsKey].custom = {};
            this.selectedAllArray[permissionsKey].all = false;
            permissionsTemplate[permissionsKey].forEach((x: any) => {
              this.permissions[permissionsKey].custom[x.id] = false;
            });
          }
          this.initData();
          this.templateLoaded = true;
          this.templateLoaded$.next(null);
        }
      }
    });
  }

  initData() {
    const permissionsTemplate = this.service.lists['roles-create'].permissions;
    for (const permissionsKey of Object.keys(permissionsTemplate)) {
      // console.log(permissionsKey);
      // console.log(this.item);
      this.permissions[permissionsKey].val = 'none-' + permissionsKey;
      if (this.isEdit || this.isClone) {
        this.clearAll(permissionsKey, false);
      } else {
        this.clearAll(permissionsKey);
      }
    }
  }

  loadData() {
    // console.log('this.item');
    // console.log(this.item);
    if (!this.item) {
      return;
    }

    if (this.item) {
      console.log(this.item);
      for (const permissionsKey of Object.keys(this.item)) {
        if (!this.item[permissionsKey].all) {
          if (this.item[permissionsKey].custom.length) {
            this.handleCustom(permissionsKey, false);
            this.permissions[permissionsKey].val = 'custom-' + permissionsKey;
            // const selectedItems: string[] = [];
            console.log(this.selectedAllArray);
            this.selectedAllArray[permissionsKey].custom = [...this.item[permissionsKey].custom];
            this.item[permissionsKey].custom.forEach((x: any) => {
              this.permissions[permissionsKey].custom[x] = true;
            });
            console.log(this.selectedAllArray);
            // this.item[permissionsKey].custom = selectedItems;
          } else {
            // this.clearAll(permissionsKey, false);
            this.permissions[permissionsKey].val = 'none-' + permissionsKey;
          }
        } else {
          this.handleAll(permissionsKey, false);
          this.permissions[permissionsKey].val = 'all-' + permissionsKey;
        }
        this.formValue = this.selectedAllArray;
        if (this.isClone) {
          this.emitValues(true, true);
        } else {
          this.emitValues(true, false);
        }
      }
    }
  }
}
